import { FormControl } from '@angular/forms';
import { IInsuranceOptionValue } from '@sondermind/utilities/models-provider-network-company';

import { IOptionCategory } from './option-category.interface';
import { IConcernOptionValue } from './specialty';

export interface IFilterForm {
  concerns: FormControl<IConcernOptionValue[]>;
  genders: FormControl<number[]>;
  insurance: FormControl<IInsuranceOptionValue | null>;
  state: FormControl<string | null>;
  city: FormControl<string | null>;
}

export interface IFilterFormValues {
  concerns: IConcernOptionValue[];
  genders: number[];
  insurance: IInsuranceOptionValue | null;
  state: string | null;
  city: string | null;
}
export interface ISeoElements {
  filterFormValues: Partial<IFilterFormValues>;
  genderOptions: Array<IOptionCategory<number>>;
}
export interface IUrlParamValues {
  genders: string;
  insurance: string;
  state: string;
  city: string;
  modalities: string;
  specialties: string;
}

export enum UrlQueryParams {
  STATE = 'state',
  CITY = 'city',
  FILTERS = 'filters',
  INSURANCE = 'insurance',
  SPECIALTIES = 'specialties',
  MODALITIES = 'modalities',
  GENDERS = 'genders',
  PSYCHIATRIC = 'psychiatric',
}
